<template>
  <div class="tax-type-modal">
    <form action="" @submit.prevent="submitCurrencyData">
      <div class="card-body">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label input-label">{{ $t('settings.currencies.name') }} <span class="text-danger"> *</span></label>
          <div class="col-sm-7">
            <base-input
              ref="name"
              :invalid="$v.formData.name.$error"
              v-model="formData.name"
              type="text"
              @input="$v.formData.name.$touch()"
            />
            <div v-if="$v.formData.name.$error">
              <span v-if="!$v.formData.name.required" class="form-group__message text-danger">{{ $tc('validation.name_required') }}</span>
              <span v-if="!$v.formData.name.minLength" class="form-group__message text-danger"> {{ $tc('validation.name_min_length', $v.formData.name.$params.minLength.min, { count: $v.formData.name.$params.minLength.min }) }} </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 col-form-label input-label">{{ $t('settings.currencies.code') }} <span class="text-danger"> *</span></label>
          <div class="col-sm-7">
            <base-input
              :invalid="$v.formData.code.$error"
              v-model="formData.code"
              type="text"
              @input="$v.formData.code.$touch()"
            />
            <div v-if="$v.formData.code.$error">
              <span v-if="!$v.formData.code.required" class="form-group__message text-danger">{{ $tc('validation.code_required') }}</span>
              <span v-if="!$v.formData.code.minLength" class="form-group__message text-danger"> {{ $tc('validation.code_min_length', $v.formData.code.$params.minLength.min, { count: $v.formData.code.$params.minLength.min }) }} </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 col-form-label input-label">{{ $t('settings.currencies.symbol') }} <span class="text-danger"> *</span></label>
          <div class="col-sm-7">
            <base-input
              :invalid="$v.formData.symbol.$error"
              v-model="formData.symbol"
              type="text"
              @input="$v.formData.symbol.$touch()"
            />
            <div v-if="$v.formData.symbol.$error">
              <span v-if="!$v.formData.symbol.required" class="form-group__message text-danger">{{ $tc('validation.symbol_required') }}</span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 col-form-label input-label">{{ $t('settings.currencies.precision') }} <span class="text-danger"> *</span></label>
          <div class="col-sm-7">
            <base-input
              :invalid="$v.formData.precision.$error"
              v-model="formData.precision"
              type="text"
              @input="$v.formData.precision.$touch()"
            />
            <div v-if="$v.formData.precision.$error">
              <span v-if="!$v.formData.precision.required" class="form-group__message text-danger">{{ $tc('validation.precision_required') }}</span>
            </div>
          </div>
        </div>

      </div>
      <div class="card-footer">
        <base-button
          :outline="true"
          class="mr-3"
          color="theme"
          type="button"
          @click="closeCurrencyModal"
        >
          {{ $t('general.cancel') }}
        </base-button>
        <base-button
          :loading="isLoading"
          :disabled="isSubmitDisabled"
          color="theme"
          icon="save"
          type="submit"
        >
          {{ !isEdit ? $t('general.save') : $t('general.update') }}
        </base-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required, minLength, between, maxLength } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
      isEdit: false,
      isLoading: false,
      formData: {
        id: null,
        name: null,
        precision: 0,
        code:null,
        symbol:null,
      },
    }
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive'
    ]),
    isSubmitDisabled() {
      return this.$v.$invalid
    }
  },
  validations: {
    formData: {
      name: {
        required,
        minLength: minLength(3)
      },
      code: {
        required,
        minLength: minLength(3)  

      },
      symbol: {
        required,
        minLength: minLength(2)
      },
      precision: {
        required,
      }
    }
  },
  
  async mounted () {
    this.$refs.name.focus = true
    if (this.modalDataID) {
      this.isEdit = true
      this.setData()
    }
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
      'resetModalData'
    ]),
    ...mapActions('currency', [
      'updateCurrency',
    ]),
    resetFormData () {
      this.formData = {
        id: null,
        name: null,
        code: null,
        symbol: null,
        precision: 0
      }
      this.$v.formData.$reset()
    },
    async submitCurrencyData () {
      this.$v.formData.$touch()

      if (this.$v.$invalid) {
        return true
      }

      this.isLoading = true
      let response
      if (this.isEdit) {
        response = await this.updateCurrency(this.formData)
      }
      if (response.data) {
        if (this.isEdit) {
          window.toastr['success'](this.$t('settings.currencies.updated_message'))
        }
        this.closeCurrencyModal()
        this.isLoading = false
        return true
      }
      window.toastr['error'](response.data.error)
    },
    async setData () {
      this.formData = {
        id: this.modalData.id,
        name: this.modalData.name,
        precision: this.modalData.precision,
        symbol: this.modalData.symbol,
        code: this.modalData.code
      }
    },
    closeCurrencyModal () {
      this.resetModalData()
      this.resetFormData()
      this.closeModal()
    }
  }
}
</script>

